export default "__VITE_ASSET__CF6OCWj4__"